import { Attribute } from './Attribute.js';

export const PRIMA_KIDS_PREPAID_SN_LIST_ATTRIBUTE_TYPE = 'PrimaKidsPrepaidSnList';
export const PRIMA_KIDS_PREPAID_SN_LIST_WAITING_ATTRIBUTE_ID = 'PrepaidSnListActivating';
export const PRIMA_KIDS_PREPAID_SN_LIST_ATTRIBUTE_ID = 'PrepaidSnList';

/**
 * @property {{sn: string, isActive: boolean}[]} values
 */
export class PrimaKidsPrepaidSnList extends Attribute {
  constructor({ values }) {
    super();
    this.values = values;
    this.isReadOnly = true;
    this.isHidden = true;
    this.type = PRIMA_KIDS_PREPAID_SN_LIST_ATTRIBUTE_TYPE;
  }
}
